/**
 * BLOCK: blog Section
 */
 registerBlockType( 'tornado/blog-home-section', {
    title: 'Latest News',
    description: __('', 'tornado'),
    icon:'editor-insertmore',
    category:'tornado',
    keywords: [ 'blog', 'tornado', 'home'],
    supports: {
        align: ['full','wide']
    },
    attributes : {
        title : {
            type: 'string',
            default: 'احدث الاخبار',
        },
        title2 : {
            type: 'string',
            default: "هذا عنوان مؤقت للمحتوي يقع هنا",
        },
        posts_number : {
            type: 'string',
            default: 4,
        },
        // query :{
        //     type : 'string' , 
        //     default : 'post'
        // }
    },
    //==== Edit Mode ====//
    edit: props => {
        const { attributes, setAttributes } = props;
        props.setAttributes( { align: 'full' } );
        //==== Set new Data ====//
        const set_title = value => setAttributes({ title: value });
        const set_title2 = value => setAttributes({ title2: value });
        const set_posts_number = value => setAttributes({ posts_number: value });
        // const set_query_name = value => setAttributes({ query: value });
        // Rendering in PHP
                         
        return (
            // alert( $post_types ),
            <Panel>
                <InspectorControls key="inspector">
                    <PanelBody title={ __('Block Options', 'tornado') }>
                        {/*=== Section Title ===*/}
                        <TextControl key="title" label="عنوان القطعه" value={ attributes.title } onChange={ set_title } />
                        {/*=== Section Title 2 ===*/}
                        <TextControl key="title2" label="العنوان الثانى " value={ attributes.title2 } onChange={ set_title2 } />
                        {/* //=== URL Input Control ===// */}
                        <TextControl type="number" key="blog-number" label="عدد البوستات" value={ attributes.posts_number } onChange={ set_posts_number } />
                      {/*=== query Title ===*/}
                     </PanelBody>
                </InspectorControls>
                <PanelBody>
                    <ServerSideRender block="tornado/blog-home-section" attributes={{
                        title   : attributes.title,
                        posts_number     : attributes.posts_number,
                        title2     : attributes.title2,
                        // query : attributes.query
                    }} />
             
                </PanelBody>
            </Panel>
        )
    },
    save() { // Rendering in PHP
        return null;
    },
});